// Memoize firefly configurations
export const fireflyConfigs = [
    { position: [2.5, -4.5, 4], scale: [1, 2, 1], count: 6 },
    { position: [-1, -5.0, 10], scale: [1, 1, 1], count: 6 },
    { position: [-6, -6.0, 15], scale: [1, 1, 1], count: 6 },
    { position: [3.8, -5.5, 14.5], scale: [1.2, 1.2, 1.2], count: 6 },
    { position: [-0.5, -5.0, 20], scale: [1, 1, 1], count: 6 },
    { position: [-12.5, -6.0, 20], scale: [1, 1, 1], count: 6 },
    { position: [-19.5, -6.0, 22], scale: [1, 1, 1], count: 6 },
    { position: [-16, -6.0, 12], scale: [1, 1, 1], count: 6 },
    { position: [-25, -6.0, 16], scale: [1, 4, 4], count: 6 }
];

export const fireFlyConfigs2D = [
    { position: [-17.58, -3.26, -10.23], scale: [1, 1, 1], count: 6 },
    { position: [-13.58, -3.26, -14.23], scale: [1, 1, 1], count: 6 },
    { position: [-21.58, -4.26, -18.23], scale: [1, 1, 1], count: 6 },
    { position: [-11.58, -4.26, -17.23], scale: [1.2, 1.2, 1.2], count: 6 },
]

// Lighting configurations
export const lightingConfig = {
    dark: {
        directional: {
            intensity: 3.8,
            color: "#2d4cff",
            position: [-45, 10, 20]
        },
        ambient: {
            intensity: 0.1,
            color: "#1a1a2e"
        },
        fill: {
            intensity: 0,
            color: "#000000"
        }
    },
    light: {
        directional: {
            intensity: 3.5,
            color: "#fff8dc",
            position: [-45, 10, 20]
        },
        ambient: {
            intensity: 0.3,
            color: "#f0f8ff" 
        },
        fill: {
            intensity: 0.1,
            color: "#87ceeb"
        }
    }
}